<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>订单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">待办员工:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.staffName" size="small"
                          @keyup.enter.native="handleSearchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">订单ID:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderId" size="small"
                          @keyup.enter.native="handleSearchList()">
                </el-input>
              </div>
            </el-col>
            <el-col :span="4" :offset="2" style="padding-left: 415px" class="display-row">
              <el-button class="search-btn lx-mb5 btn-gray" @click="handleQueryInfoClear">重置</el-button>
              <el-button class="search-btn lx-mb5 btn-blue" @click="handleSearchList" >搜索</el-button>
              <el-button class="search-btn lx-mb5 btn-blue" @click=" ModifyPageVisible = true">新增</el-button>
            </el-col>
          </el-row>
        </el-collapse>
      </div>

      <div
          slot="table"
          class="full-height display-col"
      >
        <el-table
            :data="complaintList"
            border
            style="width: 100%"
            height="550"
            v-loading="isLoading"
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
        >
          <el-table-column
              type="index"
              label="序号"
              align="center"
              width="40"
          ></el-table-column>

          <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
              width="100">
          </el-table-column>

          <el-table-column
              prop="staffName"
              label="待办员工"
              align="center"
          />
          <el-table-column
              prop="userName"
              label="客户名称"
              align="center"
          />

          <el-table-column
              prop="orderId"
              label="订单ID"
              align="center"
              min-width="100"
          />


          <el-table-column
              prop="complaintDescription"
              label="投诉说明"
              align="center"
              min-width="100"
          />

          <el-table-column
              prop="orderId"
              label="操作"
              align="center"
              min-width="100"
          >
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>

    <!--新增弹窗-->
    <el-dialog
        :visible.sync="ModifyPageVisible"
        width="61%"
        title="新增投诉"
        @close="onClose"
    >
      <el-form
          :model="complaintInfo"
          ref="complaintInfo"
          class="demo-userInfo"
          :rules="rules"
      >
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="投诉员工：" prop="staffName" label-width="120px">
              <el-input v-model="complaintInfo.staffName" style="width: 200px" size="small" disabled></el-input>
              <el-button type="primary" size="small" style="margin-left: 10px" @click="handleOpenUserList">选择员工</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="关联订单：" prop="orderId" label-width="120px">
              <el-input v-model="complaintInfo.orderId" style="width: 200px" size="small" disabled></el-input>
              <el-button type="primary" size="small" style="margin-left: 10px" @click="handleOpenOrderList">选择订单</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="关联客户：" prop="userName" label-width="120px">
              <el-input v-model="complaintInfo.userName" style="width: 200px" size="small" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="投诉说明:" label-width="120px" prop="complaintDescription">
          <el-input v-model="complaintInfo.complaintDescription" style="width: 400px" size="small" placeholder="请输入 金额+件数+说明"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeComplaintDialog">取 消</el-button>
        <el-button class="form-btn btn-blue"  type="primary" @click="submitArrivalRemind">提 交</el-button>
      </span>
    </el-dialog>

    <!--选择订单弹窗-->
    <el-dialog
        :visible.sync="orderDialog"
        width="71%"
        title="选择订单"
    >
      <el-row class="search-row" >
        <el-col :span="4" class="display-row">
          <div class="query-title">订单编号:</div>
          <div class="flex1">
            <el-input placeholder="请输入内容" clearable v-model="orderQueryInfo.id" size="small"
                      @keyup.enter.native="handleGetList()">
            </el-input>
          </div>
        </el-col>
        <el-col :span="4" class="display-row">
          <div class="query-title">用户ID:</div>
          <div class="flex1">
            <el-input placeholder="请输入内容" clearable v-model="orderQueryInfo.userName" size="small"
                      @keyup.enter.native="handleGetList()">
            </el-input>
          </div>
        </el-col>
        <el-col :span="4" class="display-row">
          <div class="query-title">状态:</div>
          <div class="flex1">
            <el-select v-model="orderQueryInfo.state" placeholder="请选择" size="small" clearable>
              <el-option key="-1" value="-1" label="全部"></el-option>
              <el-option key="1" value="1" label="待购买"></el-option>
              <el-option key="2" value="2" label="购买完"></el-option>
              <el-option key="0" value="0" label="等待入库"></el-option>
              <el-option key="4" value="4" label="已到库"></el-option>
              <el-option key="5" value="5" label="仓库保管中"></el-option>
              <el-option key="7" value="7" label="不良订单"></el-option>
              <el-option key="10" value="10" label="无法购买"></el-option>
              <el-option key="8" value="8" label="已完成"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4" :offset="1" class="display-row">
          <el-button class="search-btn lx-mb5 btn-gray" @click="orderQueryInfoClear">重置</el-button>
          <el-button class="search-btn lx-mb5 btn-blue" @click="handleSearchOrderList" >搜索</el-button>
        </el-col>
      </el-row>

      <el-row class="search-row">
        <div>
          <el-table
              :data="orderList"
              border
              style="width: 100%"
              height="400"
              v-loading="isLoading"
              :header-cell-style="tableStyle.headerStyle"
              :cell-style="tableStyle.cellStyle"
          >
            <el-table-column
                type="index"
                label="序号"
                align="center"
                width="40"
            ></el-table-column>

            <el-table-column
                prop="id"
                label="订单编号"
                align="center"
            />

            <el-table-column
                prop="realName"
                label="用户姓名"
                align="center"
            />

            <el-table-column
                prop="userName"
                label="用户ID"
                align="center"
            />

            <el-table-column
                prop="orderStatus"
                label="订单状态"
                align="center"
                min-width="100"
            >
              <template slot-scope="scope">
                {{ scope.row.orderStatus | orderStatusFilter }}
              </template>
            </el-table-column>

            <el-table-column
                prop="createTime"
                label="创建时间"
                align="center"
                width="100">
              <template slot-scope="scope">
                {{ scope.row.createTime | dateFormatToSecond }}
              </template>
            </el-table-column>

            <el-table-column
                prop="orderId"
                label="操作"
                align="center"
                min-width="100"
            >
              <template slot-scope="scope">
                <el-button  type="primary" plain @click="orderChoose(scope.row)">选中</el-button>
              </template>
            </el-table-column>

          </el-table>
          <el-pagination
              @size-change="handleSizeChangeOrder"
              @current-change="handleCurrentChangeOrder"
              :current-page="orderQueryInfo.pageNum"
              :page-sizes="[5, 10, 20, 50, 100, 200]"
              :page-size="orderQueryInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="orderTotal"
          ></el-pagination>
        </div>
      </el-row>
    </el-dialog>



    <!--选择员工弹窗-->
    <el-dialog
        :visible.sync="userDialog"
        width="71%"
        title="选择订单"
    >
      <el-row class="search-row">
        <el-col :span="5" class="display-row">
          <div class="query-title" style="float: right">所属角色:</div>
          <div class="flex1" style="float: right">
            <el-select
                v-model="userQueryInfo.roleId"
                placeholder="请选择"
                size="small"
                clearable>
              <el-option
                  v-for="item in roleList"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5" class="display-row">
          <div class="query-title">员工ID:</div>
          <div class="flex1">
            <el-input
                placeholder="请输入内容"
                clearable
                v-model="userQueryInfo.userName"
                size="small"
                @keyup.enter.native="handleSearchUserList">
            </el-input>
          </div>
        </el-col>
        <el-col :span="14" class="display-row">
          <div
              style="
                text-align: right;
                width: 100%;
                padding-right: 10px;
                float: right;">
            <el-button class="search-btn btn-gray" @click="handleQueryInfoUserClear">重置</el-button>
            <el-button class="search-btn btn-blue" @click="handleSearchUserList()">搜索</el-button>
          </div>
        </el-col>
      </el-row>

      <el-row class="search-row">
        <div>
          <el-table
              :data="workerList"
              border
              style="width: 100%"
              height="400"
              v-loading="isLoading"
              :header-cell-style="tableStyle.headerStyle"
              :cell-style="tableStyle.cellStyle"
          >
            <el-table-column type="index" align="center" label="序号" width="40">
            </el-table-column>
            <el-table-column prop="userName" label="员工ID">
            </el-table-column>
            <el-table-column prop="realName" label="员工姓名">
            </el-table-column>
            <el-table-column prop="roleName" align="center" label="所属角色">
            </el-table-column>
            <el-table-column prop="userStatus" align="center" label="员工状态">
            </el-table-column>
            <el-table-column prop="mobileNumber" align="center" label="手机号码" >
            </el-table-column>
            <el-table-column prop="createDate" align="center" sortable label="创建时间" >
              <template v-slot="scope">
                {{ scope.row.createDate | dateFormatToSecond }}
              </template>
            </el-table-column>
            <el-table-column
                prop="orderId"
                label="操作"
                align="center"
                min-width="100"
            >
              <template slot-scope="scope">
                <el-button  type="primary" plain @click="userChoose(scope.row)">选中</el-button>
              </template>
            </el-table-column>

          </el-table>
          <el-pagination
              @size-change="handleSizeChangeUser"
              @current-change="handleCurrentChangeUser"
              :current-page="userQueryInfo.pageNum"
              :page-sizes="[5, 10, 20, 50, 100, 200]"
              :page-size="userQueryInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="userTotal"
          ></el-pagination>
        </div>
      </el-row>
    </el-dialog>




  </div>
</template>

<script>

export default {
  name: 'complaint',
  data() {
    return {
      //投诉查询条件
      queryInfo:{
        pageNum:1,
        pageSize:10,
      },
      //订单查询条件
      orderQueryInfo:{
        pageNum:1,
        pageSize:5,
      },
      //员工查询条件
      userQueryInfo:{
        pageNum:1,
        pageSize:5,
      },
      //客户投诉列表数据
      complaintList:[],
      //投诉分页总条数
      total: 0,
      //订单分页总条数
      orderTotal: 0,
      //员工分页总条数
      userTotal: 0,
      //新增弹窗
      ModifyPageVisible:false,
      //选择订单弹窗
      orderDialog:false,
      //选择用户
      userDialog:false,
      //新增投诉对象
      complaintInfo:{
        staffId: '',
        staffName: '',
        orderId: '',
        userName: '',
        customerId:'',
        complaintDescription:'',
      },
      //员工集合
      workerList:[],
      //订单集合
      orderList:[],
      //用户角色
      roleList:[],
      //加载
      isLoading: false,
      //新增投诉表单验证
      rules:{
        staffName:[
          { required: true, message: '请选择员工' , trigger: 'blur' },
        ],
        orderId:[
          { required: true, message: '请选择关联订单' , trigger: 'blur'},
        ],
        userName:[
          { required:true, message: '请选择关联订单' , trigger: 'blur'},
        ],
        complaintDescription:[
          { required: true, message: '请输入投诉说明(金额+件数+说明)', trigger: 'blur' },
        ]
      }
    }
  },
  created() {
    this.handleGetList();
  },
  methods: {
    closeComplaintDialog(){
      this.ModifyPageVisible=false;
      this.$refs["complaintInfo"].clearValidate();
    },
    onClose () {
      this.ModifyPageVisible=false;
      this.$refs["complaintInfo"].clearValidate();
    },
    //打开选择订单弹窗 查询订单
    handleOpenOrderList(){
      this.orderDialog = true;
      this.handleGetOrderList()
    },
    //订单搜索重置
    orderQueryInfoClear(){
      this.orderQueryInfo = {
        pageNum:1,
        pageSize:5,
      }
      this.handleGetOrderList()
    },
    //订单搜索
    handleSearchOrderList(){
      let status = this.orderQueryInfo.state;

      if (status == -1) {
        //全部
        this.orderQueryInfo.orderStatus = '';
      } else if (status == 1) {
        //待购买
        this.orderQueryInfo.orderStatus = '1';
      } else if (status == 2) {
        //购买完
        this.orderQueryInfo.orderStatus = '2';
      } else if (status == 0) {
        //等待到库
        this.orderQueryInfo.orderStatus = '0';
      } else if (status == 4) {
        //已到货（到库，检品中，检品完，申请发货，装箱中，待发送）
        // this.orderQueryInfo.orderStatus = '4,8,12,20,48,88';
        //已到货（到库，检品中，装箱中，待发送）
        this.orderQueryInfo.orderStatus = '4,8,48,88';
      } else if (status == 5) {
        //仓库保管中
        this.orderQueryInfo.orderStatus = '16';
      } else if (status == 6) {
        //待支付、退货待支付、销毁待支付
        this.orderQueryInfo.orderStatus = '44,64,80';
      } else if (status == 7) {
        //不良订单（不良待处理，换货待发回，换货待到货，待部分退货，退货待支付，退货申请中，待退货，补发等待到货，销毁申请中，销毁待支付，待部分销毁，不良驳回）
        //不良订单（不良待处理，换货待发回，换货待到货，待部分退货，待退货，补发等待到货，待部分销毁，不良驳回）
        this.orderQueryInfo.orderStatus = '24,28,32,36,68,40,82,26';
      } else if (status == 8) {
        //已完成（已发送，已取消，已退货，已销毁）
        this.orderQueryInfo.orderStatus = '52,56,72,84';
      } else if (status == 9) {
        //代发账单(检品完、申请发货、退货申请中、销毁申请中)
        this.orderQueryInfo.orderStatus = '12,20,60,76';
      } else if (status == 10) {
        //无法购买(无法购买)
        this.orderQueryInfo.orderStatus = '89';
      }
      this.orderQueryInfo.pageNum = 1;
      this.handleGetOrderList();
    },

    //获得订单列表
    async handleGetOrderList() {
      this.isLoading = true;
      const { data: res } = await this.$http.get("order/listByStaff", { params: this.orderQueryInfo });
      this.orderList = res.data.list;
      this.orderTotal = res.data.total;
      this.isLoading = false;
    },
    //搜索待办
    handleSearchList(){
      this.queryInfo.pageNum = 1;
      this.handleGetList();
    },
    //获得客户投诉列表
    handleGetList() {
      this.isLoading = true;
      this.$http.get('oytqcComplaint/list', {params: this.queryInfo})
          .then(({ data }) => {
            if (data.code === 200) {
              this.complaintList = data.data.list;
              this.total = data.data.total;
            }
          })
      this.isLoading = false;
    },
    //提 交
    submitArrivalRemind() {
      this.$refs['complaintInfo'].validate((valid) => {
        if (valid) {
          //保存数据
          this.$http.post('oytqcComplaint/addOytqcComplaint', this.complaintInfo)
              .then(({ data }) => {
                console.log(data)
                if (data.code === 200) {
                  this.ModifyPageVisible = false
                  this.handleGetList();
                  this.$message.success('提交成功');
                  this.complaintInfo = {};
                  this.$refs['complaintInfo'].resetFields();
                }else {
                  this.$message.error(data.message);
                }
              })
        } else {
          return false;
        }
      });
    },
    //投诉分页
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.handleGetList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.handleGetList();
    },
    //订单分页
    handleSizeChangeOrder(newSize) {
      this.orderQueryInfo.pageSize = newSize;
      this.handleGetOrderList();
    },
    handleCurrentChangeOrder (newPage) {
      this.orderQueryInfo.pageNum = newPage;
      this.handleGetOrderList();
    },
    //用户分页
    handleSizeChangeUser(newSize) {
      this.userQueryInfo.pageSize = newSize;
      this.handleGetUserList();
    },
    handleCurrentChangeUser (newPage) {
      this.userQueryInfo.pageNum = newPage;
      this.handleGetUserList();
    },
    //选中订单之后
    orderChoose(param){
      this.orderDialog = false;
      this.complaintInfo.orderId = param.id;
      this.complaintInfo.userName = param.realName || param.userName;
      this.complaintInfo.customerId = param.customerUserId;
      this.orderQueryInfo = {
        pageNum:1,
        pageSize:5,
      }
      this.$refs.complaintInfo.clearValidate('orderId');
      this.$refs.complaintInfo.clearValidate('userName');
    },
    //打开选择员工弹窗 查询员工
    handleOpenUserList(){
      this.userDialog = true;
      this.getRoleList();
      this.handleGetUserList();
    },
    //获得员工列表
    async handleGetUserList() {
      const { data: res } = await this.$http.get("emp/empSystemManage/list", {
        params: this.userQueryInfo,
      });
      this.workerList = res.data.list;
      this.userTotal = res.data.total;
    },
    //获取角色列表
    async getRoleList() {
      const { data: res } = await this.$http.get("role/roleList");
      this.roleList = res.data;
    },
    //搜索员工
    handleSearchUserList(){
      this.userQueryInfo.pageNum = 1;
      this.getRoleList();
      this.handleGetUserList();
    },
    //重置员工搜索
    handleQueryInfoUserClear(){
      this.userQueryInfo = {
        userName: "",
        roleId: "",
        pageNum:1,
        pageSize:5,
      }
      this.getRoleList();
      this.handleGetUserList();
    },
    //选中员工之后
    userChoose(param){
      this.userDialog = false;
      this.complaintInfo.staffId = param.userId;
      this.complaintInfo.staffName  = param.realName;
      this.userQueryInfo = {
        userName: "",
        roleId: "",
        pageNum:1,
        pageSize:5,
      }
      this.$refs.complaintInfo.clearValidate('staffName');
    },
    //删除投诉
    handleDel(row){
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('oytqcComplaint/delcmUserComplaint', row)
            .then(({ data }) => {
              if (data.code === 200) {
                this.handleGetList();
                this.$message.success('删除成功');
              }else {
                this.$message.error(data.message);
              }
            })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //重置投诉搜索条件queryInfo
    handleQueryInfoClear(){
      this.queryInfo = {
        pageNum:1,
        pageSize:10,
      }
      this.handleGetList();
    },
    //修改状态
    handleUpdate(row,type){


      this.$confirm('是否确认完成?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let data = {};
        data ={...row};
        if (type == "1"){
          data.officeState = '1';
        }else{
          data.entryState = '1';
        }
        this.$http.post('transact/edit', data)
            .then(({ data }) => {
              if (data.code === 200) {
                this.handleGetList();
                this.$message.success('修改成功');
              }else {
                this.$message.error(data.message);
              }
            })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });








    }
  },
  watch: {

  },
  computed: {
  }
};
</script>

<style lang="less" scoped>
/deep/
  /*去除upload组件过渡效果*/
.el-upload-list__item {
  transition: none !important;
}

.bigimg /deep/ ul li {
  width: 100%;
  height: auto;
}

.bigimg /deep/ .el-upload--picture-card {
  display: none;
}

.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.split-col {
  padding-right: 20px;
}

.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.search-btn-container-status {
  text-align: left !important;
}

.mark {
  background: #dbdb86;
  text-align: left;
  margin-bottom: 10px;
}

.el-icon-close {
  cursor: pointer;
}

.dialog-account {
  display: flex;
  flex-wrap: wrap;

  /deep/.el-radio {
    width: 28%;
    margin-bottom: 10px;
  }
}
</style>
